import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Solution() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-170" data-mp="1ejauekalyg7w">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-171" data-mp="10tph9qjhov7s">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-172" data-mp="10rd2fm9130yy">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="qv9olj4tddw6" />
          There is a better way
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-174" data-mp="vumdsaj5qx1x">
          What if they begged to{' '}
          <span className="italic text-sunshine" data-id="element-175" data-mp="hvwdkm11kh9c">build</span> — instead of begging
          for more screen time?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-176" data-mp="mviub5g2wfmw">
          MakerLab gives your children 100+ hands-on robot projects they will
          genuinely want to make — built with simple everyday materials and
          guided by easy-to-follow step-by-step PDFs.
        </p>
        <div className="mt-10" data-id="element-177" data-mp="6ye1yx74tpv6">
          <CtaButton data-id="element-178" data-mp="2zonf1acy29y">Get MakerLab today</CtaButton>
        </div>
      </div>
    </section>;
}